import { multiMapProviders } from '../map/map-providers.js';
import _ from 'lodash';

export default {
  init() {
    multiMapProviders();

    $('#refineSearch').click(function(){
      $('.serviceCheckboxes').toggleClass('show');
      return false;
    });

    $('.serviceFilter').click(function(){


      let serviceArray = [];
      $('input[name=serviceCheckbox]:checked').each(function(){
          serviceArray.push($(this).val());
      });

      const urlParams = new URLSearchParams(window.location.search);

      let args = {
        'search_type': ( urlParams.get('option') ) ? urlParams.get('option') : 'initial',
        'zip': ( urlParams.get('zip') ) ? urlParams.get('zip') : null,
        'services': (serviceArray.length > 0) ? serviceArray.join(',') : null,
        'dentist_search': ($('#zipSearchForm').data('actiontype') == 'dentist') ? 'true' : null,
      }

      const argsString = '?' + new URLSearchParams(args).toString();

      const url = $('#zipSearchForm').data('action') + argsString
      const imgLoading = $('#lodashDiv').data('loader')

      $.ajax( url,
      {
          dataType: 'json', // type of response data
          timeout: 8000,     // timeout milliseconds
          beforeSend: function() {
            $('#searchFilterModal').modal('show')
            $('#ourdental .row').empty()
            $('#searchFilterModal .modal-body').html('<img src="'+imgLoading+'" /> Fetching data...')
          },
          success: function (data) {   // success callback function
            $('#ourdental').get(0).scrollIntoView();

            if (data.results.length > 0) {
              $('#totalCount').html(data.results.length);

              let output = _.template( $('#template').html() );
              $('#lodashDiv').html( output({ items: data.results }) );

              multiMapProviders();

            } else {
              $('#lodashDiv').html('No results found.');
              $('#totalCount').html('0');
            }

            $('#searchFilterModal').modal('hide')
          },
          error: function (jqXhr, textStatus, errorMessage) { // error callback
            console.log('ERROR', jqXhr, textStatus, errorMessage)
            $('#searchFilterModal .modal-body').html(errorMessage)
          },
          complete: function() {
            console.log('all done')
          },
      });

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/providerOffice.js